module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_01_6NW26_1SC_GSK.cbc7c5b2.png";